module.exports = __webpack_public_path__ + "static/img/30004 (1).f7b5ddd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30004 (1).webp
// module id = 1CBW
// module chunks = 14